import { uniqueReturnsGridColumns } from './unique-columns';

// because the returns model is similar to the shipping grid model, we reuse columns.
export const returnsGridColumns = [...uniqueReturnsGridColumns];
